/** 本文件由工具自动生成,请勿手动修改！ **/
// @ts-nocheck
import { useState,  useEffect } from 'react';
import * as R from 'ramda';
import Request, { YWRequestConfig } from '@ywfe/request';
import { getHost, reduceParams, parseParams, querystring } from '@ywfe/utils';


const { basePath = '', loginPath = '' } = getHost("PRO_SETTLE", "522")


  
    
export interface API47888Item {
  
  /** task_id */
  taskId?: number;
  
  /** 任务标题 */
  taskTitle?: string;
  
  /** 任务描述 */
  taskDesc?: string;
  
  /** <pre>,任务状态(1:未开始;2:进行中;3:已关闭;5:已完成),,详见枚举定义：com.ywwl.foundation.teamwork.client.enums.TaskStatusEnum,<pre> */
  taskStatus?: number;
  
  /** 合并状态：1:未开始;2:进行中;3:已关闭;5:已完成 */
  combStatus?: number;
  
  /** 任务完成标准(1:或签,2:会签，默认1)，详见TaskCompleteTypeEnum */
  taskCompleteType?: number;
  
  /** 计划开始时间 */
  startTime?: any;
  
  /** 计划完成时间 */
  endTime?: any;
  
  /** 实际完成时间 */
  actualEndTime?: any;
  
  /** 优先级(1:较低,2:普通,3:紧急,4:非常紧急),详见TaskPriorityEnum */
  taskPriority?: number;
  
  /** 业务数据编号 */
  planNo?: string;
  
  /** 任务创建人发起人 */
  creator?: string;
  
  /** 任务创建人姓名 */
  creatorName?: string;
  
  /** 头像 */
  creatorLogo?: string;
  
  /** 执行人列表 ,WorkTaskExecutorResult */
  taskExecutorList?: API47888Item[];
  
  /** kr编号 */
  okrKrNo?: string;
  
  /** okr-o编号 */
  okrONo?: string;
  
  /** okr进度，默认0 */
  okrProcess?: any;
  
  /**  */
  okrProcessDesc?: string;
  
  /** 权限 ,ProjectTaskAuthResp */
  authorizationResp?: any;
  
};
    
  



export interface API47888Req {
  
  /** 项目编号 */
  projectNo?: string;
    
  /** 项目计划编号、里程牌编号 */
  planNo?: string;
    
  /** 执行人id */
  executorId?: string;
    
};



export interface API47888Res {
  /**   */
  code?: string;
  /**   */
  msg?: string;
  /**   */
  success?: boolean;
  /** ProjectTaskResp  */
  data?: API47888Item[];
  /**   */
  exceptionMsg?: string;
  
};


// 47888 任务列表

export interface IUseGetAPI47888Return {
  /** 任务列表: 接口请求状态 */
  isAPI47888Loading: boolean;
  /** 任务列表: 接口请求返回数据 */
  dataAPI47888: API47888Res;
  /**  任务列表: 接口数据请求方法 */
  fetchAPI47888Data:  (inputs: API47888Req, config?: YWRequestConfig) => Promise<API47888Res>;
  /** 任务列表: 接口请求URL */
  requestUrl: string;
}

export const useGetAPI47888 = ():IUseGetAPI47888Return => {
  let isMount = true;
  const [isAPI47888Loading, setIsAPI47888Loading] = useState(false);
  const [dataAPI47888, setDataAPI47888] = useState<API47888Res>({} as API47888Res);
  const requestUrl = `${basePath}/corp-admin/project/plan/task/list`;

  const fetchAPI47888Data = async (inputs: API47888Req, config?: YWRequestConfig): Promise<API47888Res> => {
  
    
    const params = (reduceParams(inputs as unknown as R.Dictionary<API47888Req>) || {}) as API47888Req;
    
  
    if ( isMount ) {
      setIsAPI47888Loading(true);
    }

    try {
      
      
      const res: any = await Request.get<API47888Res>(`${basePath}/corp-admin/project/plan/task/list?${querystring.stringify(params as any)}`, {
        loginHost: loginPath,
        ...config
      });
      
      
      
      if (isMount) {
        setDataAPI47888(res || {} as API47888Res);
        setIsAPI47888Loading(false);
      }
      return res;
    } catch (error) {
      console.error('[ERROR] API Request Error: ', error);
      if ( isMount ) {
        setIsAPI47888Loading(false);
      }
      return false as unknown as API47888Res;
    }
  }

  useEffect(() => {
    return () => {
      isMount = false;
    };
  }, []);

  return {
    isAPI47888Loading,
    dataAPI47888,
    fetchAPI47888Data,
    requestUrl,
  }
}

